import { JoinData } from './JoinDataInt';

const roomVideoText: JoinData[] = [
    { join: "digital-press-45", name: "Back", x: 129, y: 32, width: 53, height: 36, category: "room_video_text" },
    { join: "serial-feedback-2", name: "Room Name", x: 649, y: 22, width: 88, height: 32, category: "room_video_text" },

    { join: "digital-feedback-90", name: "Select Source Feedback", x: 959, y: 21, width: 177, height: 65, group: "video_source", category: "room_video_text" },
    { join: "digital-press-90", name: "Select Source", x: 959, y: 21, width: 177, height: 65, group: "video_source", category: "room_video_text" },
    { join: "serial-feedback-12", name: "Video Source Name", x: 969, y: 31, width: 159, height: 44, category: "room_video_text" },
    { join: "digital-press-122", name: "Video Power Off", x: 1225, y: 35, width: 30, height: 30, category: "room_video_text" },

    { join: "digital-feedback-367", name: "Custom Message Visibility", x: 442, y: 386, width: 502, height: 48, group: 'custom_message', category: "room_video_text" },
    { join: "serial-feedback-55", name: "Custom Message", x: 442, y: 386, width: 502, height: 48, group: 'custom_message', category: "room_video_text" },
];

export default roomVideoText;
